import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MenuItem from 'material-ui/MenuItem'

import RotatedSquareIcon from '../../../components/RotatedSquareIcon'
import TruncatedText from '../../../components/TruncatedText'
import { DrawerBadge } from './styled-components'

class StyledMenuItem extends Component {
  static propTypes = {
    notification: PropTypes.number,
    children: PropTypes.node,
    onClick: PropTypes.func,
    focused: PropTypes.bool,
    iconColor: PropTypes.string
  }
  static defaultProps = {
    notification: 0
  }
  state = {}

  render() {
    const { focused, iconColor, notification, children, ...props } = this.props
    return (
      <MenuItem
        style={{
          paddingLeft: 35,
          backgroundColor: focused && '#EEE'
        }}
        {...props}>
        <RotatedSquareIcon color={iconColor} top="50%" left="-10px" />
        <TruncatedText>
          {notification > 0 && (
            <DrawerBadge badgeContent={notification} primary />
          )}
          {children}
        </TruncatedText>
      </MenuItem>
    )
  }
}

export default StyledMenuItem



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/components/StyledMenuItem.js